var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 1.0625C19.75 0.847009 19.6644 0.640346 19.5121 0.487973C19.3597 0.3356 19.153 0.249998 18.9375 0.249998H9.18755C8.97206 0.249998 8.7654 0.3356 8.61303 0.487973C8.46065 0.640346 8.37505 0.847009 8.37505 1.0625C8.37505 1.27799 8.46065 1.48465 8.61303 1.63702C8.7654 1.7894 8.97206 1.875 9.18755 1.875H16.9762L0.4873 18.3622C0.411757 18.4378 0.351833 18.5275 0.310949 18.6262C0.270066 18.7249 0.249023 18.8307 0.249023 18.9375C0.249023 19.0443 0.270066 19.1501 0.310949 19.2488C0.351833 19.3475 0.411757 19.4372 0.4873 19.5127C0.562842 19.5883 0.652525 19.6482 0.751227 19.6891C0.849928 19.73 0.955716 19.751 1.06255 19.751C1.16938 19.751 1.27517 19.73 1.37387 19.6891C1.47257 19.6482 1.56226 19.5883 1.6378 19.5127L18.125 3.02387V10.8125C18.125 11.028 18.2106 11.2346 18.363 11.387C18.5154 11.5394 18.7221 11.625 18.9375 11.625C19.153 11.625 19.3597 11.5394 19.5121 11.387C19.6644 11.2346 19.75 11.028 19.75 10.8125V1.0625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLinkArrow);
export default __webpack_public_path__ + "static/media/ShortLinkArrow.670b907cea402e105e5128677ad13f78.svg";
export { ForwardRef as ReactComponent };